import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00B8AD",
      "fill-rule": "evenodd",
      d: "M11 6.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0m1 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M5.451 9.52 2.785 6.854 2.43 6.5l.354-.354L5.45 3.48l.707.707L4.345 6h4.793v1H4.345l1.813 1.813z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }